import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useContext, useEffect } from 'react';
import { SiteConfigContext } from '../SiteConfigProvider';
import { isBrowser, useScript } from '@jelly/utils';
export function DfpAdUnitSetup(_ref) {
  var channels = _ref.channels,
      docType = _ref.docType,
      guid = _ref.guid;

  var _useScript = useScript('https://www.googletagservices.com/tag/js/gpt.js'),
      _useScript2 = _slicedToArray(_useScript, 2),
      loaded = _useScript2[0],
      error = _useScript2[1];

  var isArticle = 'article' === docType;

  var _useContext = useContext(SiteConfigContext),
      _useContext$siteConst = _useContext.siteConstants,
      _useContext$siteConst2 = _useContext$siteConst.DFP_CONTENT_ID_TYPE,
      DFP_CONTENT_ID_TYPE = _useContext$siteConst2 === void 0 ? 'guid' : _useContext$siteConst2,
      DFP_NETWORK_ID = _useContext$siteConst.DFP_NETWORK_ID,
      DFP_NOBID_ID = _useContext$siteConst.DFP_NOBID_ID,
      DFP_SITE_NAME = _useContext$siteConst.DFP_SITE_NAME;

  useEffect(function () {
    if (error) {
      return console.warn('Failed to load gpt.js');
    }

    if (isBrowser() && loaded) {
      var _channels$primary, _channels$sub, _channels$primary2;

      isArticle && function () {
        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://public.servenobid.com/nobidtag/nobidtag.js';
        var x = document.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      }();
      var hostname = window.location.hostname;
      var url = window.location.origin + window.location.pathname;
      var searchTerm = ''; // pulls out the first numeric part of the URL path, for example:
      // https://www.businessnewsdaily.com/5102-green-business-ideas.html
      // will produce "5102". If no number val is undefined

      var idFromHref = window.location.pathname.match(/[\d]+/); // set the content_id according to the method defined in the site config
      // if set to "prefix" and there is no number in the URL, deafult to "guid"

      var contentId = DFP_CONTENT_ID_TYPE === 'prefix' && idFromHref ? "".concat(DFP_SITE_NAME, "-").concat(idFromHref[0]) : "".concat(guid).replace(/^[a-z]+_/i, '');
      var contentType = "".concat(docType).trim().replace(/\s/g, '_');
      var pageAdZone = channels.sub ? ["".concat(channels === null || channels === void 0 ? void 0 : (_channels$primary = channels.primary) === null || _channels$primary === void 0 ? void 0 : _channels$primary.slug), "".concat(channels === null || channels === void 0 ? void 0 : (_channels$sub = channels.sub) === null || _channels$sub === void 0 ? void 0 : _channels$sub.slug)].join('/') : "".concat(channels === null || channels === void 0 ? void 0 : (_channels$primary2 = channels.primary) === null || _channels$primary2 === void 0 ? void 0 : _channels$primary2.slug);
      var pageAccount = DFP_NETWORK_ID;
      var site = DFP_SITE_NAME;
      var zoneType = site;
      var adunitZone = [pageAccount, zoneType + '-' + contentType.replace(/^\w/, function (c) {
        return c.toUpperCase();
      }), "".concat(docType)].join('/');
      var inArticleSizes = [[728, 90], [632, 81], [720, 250], [720, 400]],
          leaderboardSizes = [[728, 90], [970, 90], [970, 250], [970, 490], [970, 450], [970, 66], [930, 490], [930, 450], [930, 250], [930, 140], [632, 81]],
          mobileAdSizes = [[320, 50], [300, 50], [300, 100], [234, 60]],
          railSizes = [[300, 250], [250, 250], [336, 280], [180, 150], [200, 200]];
      window.googletag = window.googletag || {};
      window.googletag.cmd = window.googletag.cmd || [];
      window.googletag.cmd.push(function () {
        window.googletag.cmd.push(function () {
          var inArticleSizeMap = window.googletag.sizeMapping().addSize([768, 0], [320, 50]).addSize([1024, 0], [560, 60]).addSize([1200, 0], inArticleSizes).addSize([0, 0], mobileAdSizes).build();
          var leaderBoardSizeMap = window.googletag.sizeMapping().addSize([768, 0], [320, 50]).addSize([1024, 0], [560, 60]).addSize([1200, 0], leaderboardSizes).addSize([0, 0], mobileAdSizes).build();
          var railAdSizeMap = window.googletag.sizeMapping().addSize([0, 0], railSizes).build();

          if (document.getElementById('ad_leaderboard')) {
            window.googletag.defineSlot(adunitZone, [[320, 50]], 'ad_leaderboard').defineSizeMapping(leaderBoardSizeMap).addService(window.googletag.pubads()).setTargeting('position', 'a1');
          }

          window.googletag.defineOutOfPageSlot(adunitZone, 'out-of-page');

          if (document.getElementById('in-article-vca-1')) {
            window.googletag.defineSlot(adunitZone, [[320, 50]], 'in-article-vca-1').addService(window.googletag.pubads()).defineSizeMapping(inArticleSizeMap).setTargeting('position', 'a2');
          }

          if (document.getElementById('in-article-vca-2')) {
            window.googletag.defineSlot(adunitZone, [[320, 50]], 'in-article-vca-2').defineSizeMapping(inArticleSizeMap).addService(window.googletag.pubads()).setTargeting('position', 'a3');
          }

          if (document.getElementById('adunit-atf')) {
            window.googletag.defineSlot(adunitZone, [[300, 250]], 'adunit-atf').defineSizeMapping(railAdSizeMap).addService(window.googletag.pubads()).setTargeting('position', 'a2');
          }

          if (document.getElementById('adunit-btf')) {
            window.googletag.defineSlot(adunitZone, [[320, 250]], 'adunit-btf').defineSizeMapping(railAdSizeMap).addService(window.googletag.pubads()).setTargeting('position', 'a4');
          }

          window.googletag.pubads().setTargeting('content_id', contentId).setTargeting('search_term', searchTerm).setTargeting('content_type', [contentType]).setTargeting('host', hostname).setTargeting('page_zone', [pageAdZone]).setTargeting('URL', url).setTargeting('zone_type', [zoneType]);
          window.googletag.pubads().enableSingleRequest();
          window.googletag.pubads().collapseEmptyDivs(); // Only include this for nobid header code on articles

          isArticle && window.googletag.pubads().disableInitialLoad();
          window.googletag.enableServices();

          if (document.getElementById('in-article-vca-1')) {
            window.googletag.cmd.push(function () {
              window.googletag.display('in-article-vca-1');
            });
          }

          if (document.getElementById('in-article-vca-2')) {
            window.googletag.cmd.push(function () {
              window.googletag.display('in-article-vca-2');
            });
          }

          if (document.getElementById('adunit-atf')) {
            window.googletag.cmd.push(function () {
              window.googletag.display('adunit-atf');
            });
          }
        });

        if (isArticle) {
          window.nobidtag = window.nobidtag || {};
          window.nobidtag.cmd = window.nobidtag.cmd || [];
          window.googletag.cmd.push(function () {
            window.nobidtag.cmd.push(function () {
              var config = {
                siteId: DFP_NOBID_ID,
                timeout: 3000,
                adunits: [{
                  id: 'ad_leaderboard',
                  sizes: leaderboardSizes,
                  responsive: [{
                    screenWidth: 632,
                    sizes: leaderboardSizes
                  }, {
                    screenWidth: 0,
                    sizes: mobileAdSizes
                  }]
                }, {
                  id: 'adunit-atf',
                  sizes: railSizes
                }, {
                  id: 'in-article-vca-1',
                  sizes: inArticleSizes,
                  responsive: [{
                    screenWidth: 632,
                    sizes: inArticleSizes
                  }, {
                    screenWidth: 0,
                    sizes: mobileAdSizes
                  }]
                }, {
                  id: 'in-article-vca-2',
                  sizes: inArticleSizes,
                  responsive: [{
                    screenWidth: 632,
                    sizes: inArticleSizes
                  }, {
                    screenWidth: 0,
                    sizes: mobileAdSizes
                  }]
                }, {
                  id: 'adunit-btf',
                  sizes: railSizes
                }]
              };
              window.nobidtag.refreshAds(config);
            });
          });
        }
      });
    }
  }, [loaded, error, guid, docType, channels, isArticle, DFP_NETWORK_ID, DFP_SITE_NAME, DFP_NOBID_ID, DFP_CONTENT_ID_TYPE]);
  return null;
}